module.exports = __webpack_public_path__ + "img/marketplace_FB.4ea4f04c.svg";